import { Button } from '@opendoor/mosaic';
import { FilterChip, useIndxResults, useUserFilters } from '@opendoor/tessellation';

import MarketFilter from './MarketFilter';
import SearchAddressFilter from './SearchAddressFilter';
import WorkOrderTypeFilter from './WorkOrderTypeFilter';

const MAX_RESULTS_COUNT = 10000;

export const AppliedFilters = () => {
  const { userFilters, removeFilter } = useUserFilters();
  const { size = 0 } = useIndxResults();

  const handleDelete = (field: string) => {
    removeFilter(field);
  };

  return (
    <div className="flex flex-row pv-2 items-center">
      <span>{size >= MAX_RESULTS_COUNT ? '9999+' : size} results found</span>
      {userFilters
        .filter((filter) => filter.displayName && filter.field !== 'progress')
        .map((filter) => (
          <div key={filter.displayName} className="pl-2">
            <FilterChip
              filter={filter}
              onDelete={() => {
                handleDelete(filter.field);
              }}
            />
          </div>
        ))}
      <div className="ml-2">
        <Button
          variant="text"
          color="primary"
          size="small"
          onClick={() => {
            removeFilter('address.full_address');
            removeFilter('market');
            removeFilter('kind');
          }}
        >
          Reset Filters
        </Button>
      </div>
    </div>
  );
};

const FilterWorkOrders = () => {
  return (
    <div style={{ maxWidth: '230px' }} className="flex flex-column mt-4 ml-2 mr-4">
      <div className="mb-2">
        <SearchAddressFilter placeholder="Search address" />
      </div>
      <div className="mt-2 mb-2">
        <MarketFilter field="market" />
      </div>
      <div className="mt-2">
        <WorkOrderTypeFilter field="kind" />
      </div>
    </div>
  );
};

export default FilterWorkOrders;
